export default "__VITE_ASSET__CJGpEXKB__"